<template>
  <div class="pending-viz-container">
    <div class="blueprint-bg"></div>
    <div class="content-box">
      <div class="icon-wrapper">
        <i class="el-icon-cpu"></i>
        <div class="pulse-ring"></div>
      </div>
      <h2 class="title">思维可视化模型构建中</h2>
      <p class="description">
        知识点：<span class="kp-name">{{ knowledgePoint }}</span>
      </p>
      <div class="status-tag">
        <i class="el-icon-loading"></i>
        <span>该知识点思维可视化待开发</span>
      </div>
      
      <div class="grid-overlay"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PendingViz',
  props: {
    knowledgePoint: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.pending-viz-container {
  flex: 1;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: radial-gradient(circle at center, #1a2a44 0%, #0f172a 100%);
  border-radius: 12px;
  overflow: hidden;
  color: #fff;
  font-family: 'Inter', -apple-system, sans-serif;
}

.blueprint-bg {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(rgba(37, 99, 235, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(37, 99, 235, 0.1) 1px, transparent 1px);
  background-size: 40px 40px;
  opacity: 0.5;
}

.grid-overlay {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(rgba(37, 99, 235, 0.05) 2px, transparent 2px),
    linear-gradient(90deg, rgba(37, 99, 235, 0.05) 2px, transparent 2px);
  background-size: 200px 200px;
}

.content-box {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 40px;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  max-width: 450px;
  width: 90%;
  animation: fadeInUp 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.icon-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(37, 99, 235, 0.1);
  border-radius: 20px;
  color: #3b82f6;
  font-size: 40px;

  i {
    z-index: 2;
  }
}

.pulse-ring {
  position: absolute;
  inset: -4px;
  border: 2px solid rgba(59, 130, 246, 0.5);
  border-radius: 22px;
  animation: pulse 2s infinite;
}

.title {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: -0.025em;
  background: linear-gradient(to right, #fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.description {
  font-size: 16px;
  color: #94a3b8;
  margin-bottom: 24px;
  line-height: 1.6;

  .kp-name {
    color: #3b82f6;
    font-weight: 600;
  }
}

.status-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(37, 99, 235, 0.15);
  border: 1px solid rgba(37, 99, 235, 0.3);
  border-radius: 100px;
  color: #60a5fa;
  font-size: 14px;
  font-weight: 600;

  i {
    font-size: 16px;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  70% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}
</style>
